import { FC } from 'react';
import { AllieIconProps } from '../../../components';

export const EyeCloseIcon: FC<AllieIconProps> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
    <g clipPath="url(#clip0_16049_1421)">
      <path
        // eslint-disable-next-line max-len
        d="M8.24967 3.63262C8.82328 3.49835 9.41056 3.43123 9.99967 3.43262C15.833 3.43262 19.1663 10.0993 19.1663 10.0993C18.6605 11.0456 18.0572 11.9366 17.3663 12.7576M11.7663 11.8659C11.5375 12.1116 11.2615 12.3086 10.9548 12.4452C10.6481 12.5819 10.3171 12.6553 9.98142 12.6613C9.64574 12.6672 9.31231 12.6054 9.00102 12.4797C8.68972 12.354 8.40694 12.1668 8.16955 11.9294C7.93215 11.692 7.745 11.4092 7.61926 11.0979C7.49353 10.7866 7.43178 10.4532 7.4377 10.1175C7.44362 9.78186 7.5171 9.45082 7.65374 9.14416C7.79038 8.83749 7.98738 8.56149 8.23301 8.33262M0.833008 0.932617L19.1663 19.2659M14.9497 15.0493C13.5252 16.1351 11.7906 16.7367 9.99967 16.7659C4.16634 16.7659 0.833008 10.0993 0.833008 10.0993C1.86958 8.16753 3.30729 6.47979 5.04967 5.14928L14.9497 15.0493Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_16049_1421">
        <rect width="20" height="20" fill="white" transform="translate(0 0.0996094)" />
      </clipPath>
    </defs>
  </svg>
);
